export class ByQuantity {
  constructor(priceByQuantityEl, quantitySelectorForm) {
    if (!priceByQuantityEl || !quantitySelectorForm) {
      return;
    }
    this.quantitySelectorEl = quantitySelectorForm.querySelector('.js-input-counter');
    if (!this.quantitySelectorEl) {
      return;
    }
    this.min = parseFloat(this.quantitySelectorEl.getAttribute('min') || this.quantitySelectorEl.dataset.min);
    this.max = parseFloat(this.quantitySelectorEl.getAttribute('max') || this.quantitySelectorEl.dataset.max);
    this.querySelectorButtonsEl = quantitySelectorForm.querySelectorAll('.js-quantity__buttons');
    this.quantitySelectorEl.addEventListener('input', () => this.updateCheckbox());
    for (let button of this.querySelectorButtonsEl) {
      button.addEventListener('click', e => setTimeout(() => this.updateCheckbox(), 25));
    }
    this.values = [];
    const optionsListEl = priceByQuantityEl.querySelector('.js-form-field-list');
    this.checkboxsEl = optionsListEl.querySelectorAll('.js-form-checkbox');
    for (let checkbox of this.checkboxsEl) {
      checkbox.addEventListener('change', e => this.updateFromCheckbox(e));
      this.values.push(Number.parseInt(checkbox.value));
    }
    this.updateCheckbox();
  }
  updateCheckbox() {
    const closestValue = this._getClosestValue(Number.parseInt(this.quantitySelectorEl.value));
    for (let checkbox of this.checkboxsEl) {
      checkbox.checked = false;
      if (closestValue && checkbox.value == closestValue) checkbox.checked = true;
    }
    this._disableButtons();
  }
  updateFromCheckbox(e) {
    if (e.target.checked) {
      this.quantitySelectorEl.value = e.target.value;
    } else {
      this.quantitySelectorEl.value = 1;
    }
    const myEvent = new CustomEvent('QUANTITY_UPDATED');
    this.quantitySelectorEl.dispatchEvent(myEvent);
    this.updateCheckbox();
    this._disableButtons();
  }
  _getClosestValue(inputValue) {
    const values = this.values.filter(element => element <= inputValue);
    if (values.length === 0) {
      return null;
    }
    return Math.max(...values);
  }
  _disableButtons() {
    switch (this.quantitySelectorEl.value) {
      case this.min:
        this.querySelectorButtonsEl[0].disabled = true;
        this.querySelectorButtonsEl[1].disabled = false;
        break;
      case this.max:
        this.querySelectorButtonsEl[0].disabled = false;
        this.querySelectorButtonsEl[1].disabled = true;
        break;
      default:
        this.querySelectorButtonsEl[0].disabled = false;
        this.querySelectorButtonsEl[1].disabled = false;
    }
  }
}